type AvatarSourceUser = {
  image?: string | null;
  imageStorageKey?: string | null;
};

/**
 * The reference `UserAvatarDisplay` resolves (#5904). A profile photo's
 * storage key resolves only for its uploader, but saving the photo also
 * writes the same image as the public `image` URL. Prefer that URL so every
 * member sees the photo, then the key, then a legacy `_storage` id in `image`.
 */
export function pickUserAvatarSource(
  user: AvatarSourceUser | null | undefined
): string | null {
  const image = user?.image?.trim() || null;
  if (image && /^https?:\/\//i.test(image)) return image;
  return user?.imageStorageKey?.trim() || image;
}
